/* Export HTML autosufficiente e interattivo: riempie il template del viewer
   (il file originale con segnaposto) con i dati correnti, riconvertiti nel
   formato che il viewer si aspetta (PARTICIPANTS con color singolo +
   ACTOR_COLORS per tema). */
import type { DiagramDoc } from "@fullsteps/shared";
import viewerTemplate from "../generated/viewer-template.html?raw";

const inj = (o: unknown): string => JSON.stringify(o).replace(/</g, "\\u003c");

/** Il titolo finisce dentro il markup: va reso innocuo. */
const escHtml = (s: string): string =>
  s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

export function buildExportHtml(doc: DiagramDoc): string {
  const participants = doc.participants.map((p) => ({
    id: p.id,
    name: p.name,
    kind: p.kind,
    ...(p.temp ? { temp: true } : {}),
    color: p.colors.dark,
    icon: p.icon,
  }));
  const actorColors = {
    dark: Object.fromEntries(doc.participants.map((p) => [p.id, p.colors.dark])),
    light: Object.fromEntries(doc.participants.map((p) => [p.id, p.colors.light])),
  };

  // Il template è ricavato da flusso-urgenze.html e porta con sé il titolo di
  // quel diagramma: qui va sostituito con quello vero, altrimenti l'HTML
  // condiviso con un cliente si presenta come "Flusso urgenze".
  const title = escHtml(doc.meta.title);

  return viewerTemplate
    .replace(/<title>[^<]*<\/title>/, `<title>${title} — diagramma interattivo</title>`)
    .replace(/<h1>[^<]*<small>/, `<h1>${title} <small>`)
    .replace("/*__PARTICIPANTS__*/[]", inj(participants))
    .replace("/*__DOCS__*/[]", inj(doc.docs))
    .replace("/*__FLOW__*/[]", inj(doc.flow))
    .replace("/*__ACTOR_COLORS__*/{}", inj(actorColors));
}
